<h5>
  <div *ngIf="plc?.id !== 0">
    <span *ngIf="plc?.client?.site?.id" class="space">
    <label class="badge badge-secondary">
      <yo-site [siteId]="plc?.client?.site?.id" [siteLibelle]="plc?.client?.site?.libelle"></yo-site>
    </label>
    </span>

    <label class="badge badge-secondary mg-r-20">
      <i class="fas fa-handshake mg-r-5"></i>
      <yo-viewmode
        [yoLabelFab]="'Client'" [libelle]="plc?.libelle"
        [siteId]="plc?.client?.site?.id">
      </yo-viewmode>
    </label>
  </div>
  <div *ngIf="plc?.id === 0">
    <label class="badge badge-secondary">
      <i class="fas fa-handshake"></i>
      <span class="mg-l-5">Création d'un point de livraison client</span>
    </label>
  </div>
</h5>
<p-tabMenu [model]="navLinks" [activeItem]="selectedNavLink"></p-tabMenu>
<div class="mg-t-15">
  <router-outlet></router-outlet>
</div>
